export const gridBaseSize = 8 // px

export enum Size {
  none = 0,
  tiny = gridBaseSize / 2, // 4 px
  base = gridBaseSize, // 8px
  mini = gridBaseSize * 2, // 16px
  small = gridBaseSize * 3, // 24px
  medium = gridBaseSize * 4, // 32 px
  large = gridBaseSize * 6, // 48 px
  xlarge = gridBaseSize * 8, // 64 px
  huge = gridBaseSize * 12, // 96 px
}

export type SizeName = 'none' | 'tiny' | 'base' | 'mini' | 'small' | 'medium' | 'large' | 'xlarge' | 'huge'

export interface SizesInterface {
  /** 0 px */
  none: Size
  /** 4 px */
  tiny: Size
  /** 8 px */
  base: Size
  /** 16 px */
  mini: Size
  /** 24 px */
  small: Size
  /** 32 px */
  medium: Size
  /** 48 px */
  large: Size
  /** 64 px */
  xlarge: Size
  /** 96 px */
  huge: Size
  scale: (factor: number) => number
}

export const sizes = {
  none: Size.none,
  tiny: Size.tiny,
  mini: Size.mini,
  small: Size.small,
  base: Size.base,
  medium: Size.medium,
  large: Size.large,
  xlarge: Size.xlarge,
  huge: Size.huge,
  scale: (factor: number) => factor * gridBaseSize,
}



// WEBPACK FOOTER //
// ./src/utils/theme/size.ts